export enum Language {
    ENGLISH = 'en-us',
    FRENCH = 'fr-ca',
}
